import { create } from 'zustand';

interface TranscriptState {
  transcript: string;
  isRecording: boolean;
  setTranscript: (text: string) => void;
  appendTranscript: (text: string) => void;
  setIsRecording: (recording: boolean) => void;
}

export const useTranscriptStore = create<TranscriptState>((set) => ({
  transcript: '',
  isRecording: false,
  setTranscript: (text) => set({ transcript: text }),
  appendTranscript: (text) => set((state) => ({ transcript: state.transcript + ' ' + text })),
  setIsRecording: (recording) => set({ isRecording: recording }),
}));